<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>
    <div class="form-npa edit user-view-edit">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile"/>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  dark
                  v-on="on"
                  class="navbar-toggler-profile"
                >
                  {{ $t('Профиль') }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile"/>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="view-npa-body">
            <div class="form-group">
              <div class="search-result">
                <div class="table-overflow">
                  <table class="table">
                    <tbody>
                    <tr>
                      <th>{{ $t('Дата') }}</th>
                      <td>
                        <template v-if="!fields.date_and_creation_date.showEdit">
                          {{ new Date(appeal.date_and_creation_date) | dateFormat('DD.MM.YYYY')}}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Электронный адрес почты') }}</th>
                      <td>
                        <template v-if="!fields.email.showEdit">
                          {{ appeal.email }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Статус обращения') }}</th>
                      <td>
                        <History
                          :histories="histories"
                          :statusName="appeal.appeal_status.transName"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Тип обращения') }}</th>
                      <td>
                        <template v-if="!fields.appeal_type.showEdit">
                          {{ appeal.appeal_type.transName }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.appeal_type"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.appeal_type.showEdit && editable"
                          @click="fields.appeal_type.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Тип заявителя') }}</th>
                      <td>
                        <template v-if="!fields.applicant_type.showEdit">
                          {{ appeal.applicant_type.transName }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.applicant_type"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.applicant_type.showEdit && editable"
                          @click="fields.applicant_type.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('ФИО') }}</th>
                      <td>
                        <template v-if="!fields.fullname.showEdit">
                          {{ appeal.second_name }} {{ appeal.first_name }} {{ appeal.last_name }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.fullname"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.fullname.showEdit && editable"
                          @click="fields.fullname.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="appeal.applicant_type.id === applicantTypeIds.legalEntity">
                      <th>{{ $t('ИНН') }}</th>
                      <td>
                        <template v-if="!fields.inn.showEdit">
                          {{ appeal.inn }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.inn"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.inn.showEdit && editable"
                          @click="fields.inn.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="appeal.applicant_type.id === applicantTypeIds.legalEntity">
                      <th>{{ $t('Наименование') }}</th>
                      <td>
                        <template v-if="!fields.name.showEdit">
                          {{ appeal.name }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.name"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.name.showEdit && editable"
                          @click="fields.name.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="appeal.applicant_type.id === applicantTypeIds.legalEntity">
                      <th>{{ $t('Организационно-правовая форма') }}</th>
                      <td>
                        <template v-if="!fields.formOfIncorporation.showEdit">
                          {{ appeal.form_of_incorporation ? appeal.form_of_incorporation.transName : ''}}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.formOfIncorporation"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.formOfIncorporation.showEdit && editable"
                          @click="fields.formOfIncorporation.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr v-if="appeal.applicant_type.id === applicantTypeIds.legalEntity">
                      <th>{{ $t('Должность') }}</th>
                      <td>
                        <template v-if="!fields.position.showEdit">
                          {{ appeal.position }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.position"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.position.showEdit && editable"
                          @click="fields.position.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Кому') }}</th>
                      <td>
                        <template v-if="!fields.whom.showEdit">
                          {{ appeal.whom.transName }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.whom"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.whom.showEdit && editable"
                          @click="fields.whom.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Текст обращения') }}</th>
                      <td>
                        <template v-if="!fields.text.showEdit">
                          {{ appeal.text }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.text"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.text.showEdit && editable"
                          @click="fields.text.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('IP адрес') }}</th>
                      <td>
                        <template v-if="!fields.ip.showEdit">
                          {{ appeal.ip }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Адрес') }}</th>
                      <td>
                        <template v-if="!fields.address.showEdit">
                          {{ appeal.address }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.address"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.address.showEdit && editable"
                          @click="fields.address.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Телефон') }}</th>
                      <td>
                        <template v-if="!fields.phone.showEdit">
                          {{ appeal.phone }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.phone"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.phone.showEdit && editable"
                          @click="fields.phone.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Файлы') }}</th>
                      <td>
                        <template v-if="!fields.files.showEdit">
                          <ul class="files-l" v-for="file in files" :key="file.name">
                            <li>
                              <a :href="baseUrl + file.link" target="_blank">{{ file.name }}</a>
                            </li>
                          </ul>
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Номер') }}</th>
                      <td>
                        <template v-if="!fields.number.showEdit">
                          {{ appeal.number }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th colspan="2"></th>
                    </tr>
                    <tr>
                      <th>{{ $t('Ответ дал') }}</th>
                      <td>
                        <template v-if="!fields.reply_user.showEdit">
                          {{ appeal.reply_user ? appeal.reply_user.second_name : '' }}
                          {{ appeal.reply_user ? appeal.reply_user.first_name : '' }}
                          {{ appeal.reply_user ? appeal.reply_user.last_name : '' }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Соисполнители') }}</th>
                      <td>
                        <template v-if="!fields.collaborators.showEdit">
                          {{ appeal.collaborators }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.collaborators"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.collaborators.showEdit && editable"
                          @click="fields.collaborators.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Текст ответа') }}</th>
                      <td>
                        <template v-if="!fields.reply_text.showEdit">
                          {{ appeal.reply_text }}
                        </template>
                        <template v-else-if="editable">
                          <InlineEdit
                            :params="fields.reply_text"
                            @update-field="updateField($event)"
                          />
                        </template>
                        <a
                          v-if="!fields.reply_text.showEdit && editable"
                          @click="fields.reply_text.showEdit = true"
                          class="edit-btn"
                        >
                          <span class="pro-icon-pencil"></span>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <th>{{ $t('Файлы ответа') }}</th>
                      <td>
                        <ReplyFiles
                          :editable="editable"
                          v-bind:files.sync="replyFiles"
                        />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group form-action">
            <template v-for="actionPermission in actionPermissions">
              <v-btn
                class="btn-default"
                :key="actionPermission.id"
                @click="action(actionPermission)"
                :class="actionPermission.class"
                rounded
              >
                {{ actionPermission.name }}
              </v-btn>
              <template v-if="actionPermission.type == 'appeal_status_form'">
                <v-dialog
                  v-model="rejectDialog"
                  scrollable
                  max-width="600px"
                  :key="'action_'+actionPermission.id"
                >
                  <v-card class="modal observer-modal">
                    <div class="modal-head">
                      {{ $t('Смена статуса') }}
                      <v-btn color="modal-close" @click.native="rejectDialog = false, rejectAppeal = {}">
                        <span class="pro-icon-close1"></span>
                      </v-btn>
                    </div>
                    <div class="modal-body">
                      <v-row>
                        <v-col cols="4" md="4" class="input-label">
                          <v-label>
                            {{ $t('Причина отказа') }}: <span class="asterix">*</span>
                          </v-label>
                        </v-col>
                        <v-col class="input-field">
                          <v-select
                            v-model="rejectAppeal.reasonRejectAppeal"
                            :items="refReasonRejectAppeal"
                            item-value="id"
                            item-text="transName"
                            outlined
                            dense
                            clearable
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4" md="4" class="input-label">
                          <v-label>
                            {{ $t('Примечание') }}:
                          </v-label>
                        </v-col>
                        <v-col class="input-field">
                          <v-textarea
                            v-model="rejectAppeal.note"
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <div class="form-action">
                        <button
                          class="btn btn-default"
                          type="button"
                          @click="rejectDialog = false, rejectAppeal = {}"
                        >
                          {{ $t('Отмена') }}
                        </button>
                        <button
                          class="btn btn-default blue"
                          type="button"
                          @click="changeStatus(actionPermission.id)"
                        >
                          {{ $t('Сохранить') }}
                        </button>
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
              </template>
              <template v-else-if="actionPermission.type == 'appeal_reply'">
                <v-dialog
                  v-model="previewDialog"
                  scrollable
                  max-width="600px"
                  :key="'action_'+actionPermission.id"
                >
                  <v-card class="modal observer-modal">
                    <div class="modal-head">
                      {{ $t('Предпросмотр сообщения') }}
                      <v-btn color="modal-close" @click.native="previewDialog = false">
                        <span class="pro-icon-close1"></span>
                      </v-btn>
                    </div>
                    <div class="modal-body">
                      <v-row>
                        <div v-html="contentMessage"></div>
                      </v-row>
                      <div class="form-action">
                        <button
                          class="btn btn-default"
                          type="button"
                          @click="previewDialog = false"
                        >
                          {{ $t('Отмена') }}
                        </button>
                        <button
                          class="btn btn-default blue"
                          type="button"
                          @click="sendAppealReply"
                        >
                          {{ $t('Отправить') }}
                        </button>
                      </div>
                    </div>
                  </v-card>
                </v-dialog>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Appeal from '@/model/appeal'
  import User from '@/model/user'
  import Widget from '@/components/app/Widget'
  import InlineEdit from '@/components/appeal/InlineEdit'
  import {mapMutations} from 'vuex'
  import ReplyFiles from '@/components/appeal/ReplyFiles'
  import History from "@/components/appeal/History";
  import { Trans } from "@/plugins/Translation"

  export default {
    components: {
      History,
      Widget,
      InlineEdit,
      ReplyFiles
    },
    data() {
      return {
        appeal: {},
        breadcrumbs: [],
        files: [],
        replyFiles: [],
        fields: null,
        note: null,
        editable: false,
        rejectDialog: false,
        previewDialog: false,
        contentMessage: null,
        replyData: {},
        rejectAppeal: {},
        refReasonRejectAppeal: [],
        actionPermissions: [],
        applicantTypeIds: [],
        baseUrl: process.env.VUE_APP_BACK_URL,
        histories: []
      }
    },
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData'
    },
    created() {
      // загружаем данные, когда представление создано
      // и данные реактивно отслеживаются
      this.fetchData()
      this.scrollToTop()
      this.$store.dispatch('fetchCurrentUser')
    },
    methods: {
      ...mapMutations(['setLoading']),
      // подгрузка данных
      fetchData() {
        this.setLoading(true)
        Appeal.getAppealInfo(this.$route.params.id)
          .then((response) => {
            this.appeal = response.data.appeal
            this.histories = response.data.histories
            this.files = response.data.files
            this.replyFiles = response.data.replyFiles
            this.applicantTypeIds = response.data.applicantTypeIds
            this.setLoading(false)
            this.initFields()
            this.getActions(this.appeal.appeal_status.id)
            this.generateBreadcrumbs()
            this.editable = false
          })
      },
      // генерация хлебных крошек
      generateBreadcrumbs() {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Обращения'), disabled: false, href: Trans.currentLocaleUrl + '/appeals'},
          {text: this.$i18n.t('Просмотр обращения'), disabled: true},
        ]
      },
      //
      initFields() {
        this.fields = {
          email: {
            name: 'email',
            showEdit: false,
            fields: [
              {
                name: 'email',
                label: this.$i18n.t('Электронный адрес почты'),
                value: this.appeal.email,
                type: 'varchar'
              }
            ]
          },
          date_and_creation_date: {
            name: 'date',
            showEdit: false,
            fields: [
              {
                name: 'date',
                label: this.$i18n.t('Дата'),
                value: this.appeal.date_and_creation_date,
                type: 'varchar'
              }
            ]
          },
          fullname: {
            name: 'fullname',
            showEdit: false,
            fields: [
              {
                name: 'second_name',
                label: this.$i18n.t('Фамилия'),
                value: this.appeal.second_name,
                type: 'varchar'
              },
              {
                name: 'first_name',
                label: this.$i18n.t('Имя'),
                value: this.appeal.first_name,
                type: 'varchar'
              },
              {
                name: 'last_name',
                label: this.$i18n.t('Отчество'),
                value: this.appeal.last_name,
                type: 'varchar'
              }
            ]
          },
          appeal_status: {
            name: 'appeal_status',
            showEdit: false,
            fields: [
              {
                name: 'appeal_status',
                label: this.$i18n.t('Статус обращения'),
                value: this.appeal.appeal_status.transName,
                type: 'varchar'
              }
            ]
          },
          appeal_type: {
            name: 'appeal_type',
            showEdit: false,
            model: 'appeal_type',
            fields: [
              {
                name: 'appealType',
                label: this.$i18n.t('Тип обращения'),
                value: this.appeal.appeal_type.transName,
                type: 'references'
              }
            ]
          },
          applicant_type: {
            name: 'applicant_type',
            showEdit: false,
            model: 'applicant_type',
            fields: [
              {
                name: 'applicantType',
                label: this.$i18n.t('Тип заявителя'),
                value: this.appeal.applicant_type.transName,
                type: 'references'
              }
            ]
          },
          inn: {
            name: 'inn',
            showEdit: false,
            fields: [
              {
                name: 'inn',
                label: this.$i18n.t('ИНН'),
                value: this.appeal.inn,
                type: 'varchar'
              }
            ]
          },
          name: {
            name: 'name',
            showEdit: false,
            fields: [
              {
                name: 'name',
                label: this.$i18n.t('Наименование'),
                value: this.appeal.name,
                type: 'varchar'
              }
            ]
          },
          formOfIncorporation: {
            name: 'formOfIncorporation',
            showEdit: false,
            model: 'formOfIncorporation',
            fields: [
              {
                name: 'formOfIncorporation',
                label: this.$i18n.t('Организационно-правовая форма'),
                value: this.appeal.form_of_incorporation ? this.appeal.form_of_incorporation.transName : '',
                type: 'references'
              }
            ]
          },
          whom: {
            name: 'whom',
            showEdit: false,
            model: 'whom',
            fields: [
              {
                name: 'whom',
                label: this.$i18n.t('Кому'),
                value: this.appeal.whom.transName,
                type: 'references'
              }
            ]
          },
          text: {
            name: 'text',
            showEdit: false,
            fields: [
              {
                name: 'text',
                label: this.$i18n.t('Текст обращения'),
                value: this.appeal.text,
                type: 'textarea'
              }
            ]
          },
          collaborators: {
            name: 'collaborators',
            showEdit: false,
            fields: [
              {
                name: 'collaborators',
                label: this.$i18n.t('Соисполнители'),
                value: this.appeal.collaborators,
                type: 'textarea'
              }
            ]
          },
          ip: {
            name: 'ip',
            showEdit: false,
            fields: [
              {
                name: 'ip',
                label: this.$i18n.t('IP адрес'),
                value: this.appeal.ip,
                type: 'varchar'
              }
            ]
          },
          phone: {
            name: 'phone',
            showEdit: false,
            fields: [
              {
                name: 'phone',
                label: this.$i18n.t('Телефон'),
                value: this.appeal.phone,
                type: 'varchar'
              }
            ]
          },
          number: {
            name: 'number',
            showEdit: false,
            fields: [
              {
                name: 'number',
                label: this.$i18n.t('Номер'),
                value: this.appeal.number,
                type: 'varchar'
              }
            ]
          },
          position: {
            name: 'position',
            showEdit: false,
            fields: [
              {
                name: 'position',
                label: this.$i18n.t('Должность'),
                value: this.appeal.position,
                type: 'varchar'
              }
            ]
          },
          address: {
            name: 'address',
            showEdit: false,
            fields: [
              {
                name: 'address',
                label: this.$i18n.t('Адрес'),
                value: this.appeal.address,
                type: 'varchar'
              }
            ]
          },
          files: {
            name: 'files',
            showEdit: false,
            fields: [
              {
                name: 'files',
                label: this.$i18n.t('Файлы'),
                value: this.appeal.files,
                type: 'varchar'
              }
            ]
          },
          reply_text: {
            name: 'reply_text',
            showEdit: false,
            fields: [
              {
                name: 'replyText',
                label: this.$i18n.t('Текст ответа'),
                value: this.appeal.reply_text,
                type: 'textarea'
              }
            ]
          },
          reply_user: {
            name: 'reply_user',
            showEdit: false,
          },
          reply_files: {
            name: 'reply_files',
            showEdit: false,
            fields: [
              {
                name: 'reply_files',
                label: this.$i18n.t('Файлы ответа'),
                value: this.replyFiles,
                type: 'files'
              }
            ]
          },
        }
      },
      // список действий
      getActions(statusId) {
        User.getActionPermissionsAppeal(statusId)
          .then((res) => {
            this.actionPermissions = res.data
          })
          .catch((err) => console.log(err))
      },
      // действия
      action(actionPermission) {
        if (actionPermission.type === 'appeal_status_form') {
          this.rejectDialog = true
          Appeal.getRejectFormData()
            .then((res) => this.refReasonRejectAppeal = res.data.refReasonRejectAppeal)
            .catch((err) => console.log(err))
        } else if (actionPermission.type === 'appeal_edit') {
          this.editable = true
        } else if (actionPermission.type === 'appeal_cancel') {
          this.$router.push(Trans.i18nRoute({name: 'appealsList'}))
        } else if (actionPermission.type === 'appeal_status') {
          if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
            this.changeStatus(actionPermission.id)
          }
        } else if (actionPermission.type === 'appeal_action_cancel') {
          if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
            this.changeStatus(actionPermission.id)
          }
        } else if (actionPermission.type === 'appeal_reply') {
          if (this.appeal.is_replied) {
            this.$noty.warning(this.$i18n.t('Ответ уже был отправлен'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            return
          }
          this.previewDialog = true
          Appeal.previewMessage(this.appeal.id)
            .then((res) => this.contentMessage = res.data.content)
            .catch((err) => console.log(err))
        }
      },
      // Смена статуса
      changeStatus(id) {
        this.rejectAppeal.action_permission_id = id
        Appeal.changeStatus(this.appeal.id, this.rejectAppeal)
          .then((res) => {
            this.rejectDialog = false
            if (res.status === 200) this.fetchData()
          })
          .catch((err) => {
            if (err.response.status === 400) {
              this.$noty.error(this.$i18n.t(`${err.response.data.message}`), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
              this.rejectDialog = false
              this.rejectAppeal = {}
              return
            }
          })
      },
      // изменение полей
      updateField(result) {
        if (result.status) {
          if (result.appeal) {
            this.appeal = result.appeal
          }
          this.fields[result.fieldName].showEdit = false
        }
      },
      sendAppealReply() {
        this.replyData.content = this.contentMessage
        this.replyData.email = this.appeal.email
        Appeal.sendReply(this.appeal.id, this.replyData)
          .then((res) => {
            if (res.status === 200) {
              this.appeal.is_replied = res.data.is_replied
              this.$noty.success(this.$i18n.t('Сообщение успешно отправлено'), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
            this.previewDialog = false
          })
          .catch((err) => {
            if (err.response.status === 204) {
              this.$noty.error(this.$i18n.t(error.response.data.message), {
                killer: true,
                timeout: 1000,
                layout: 'topRight'
              })
            }
          })
      },
      // Прокручивание к началу страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      },
    }
  }
</script>
